<template>
  <b-card>
    <b-card-title>Teklif Özeti</b-card-title>
    <b-card-text>
      <b-list-group v-if="id_customers">
        <b-list-group-item v-if="id_customers.company">
          <div class="font-weight-bolder">
            Firma:
          </div>
          <div>{{ id_customers.company }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="id_customers.name">
          <div class="font-weight-bolder">
            İlgili Kişi:
          </div>
          <div>{{ id_customers.name }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="id_customers.phone">
          <div class="font-weight-bolder">
            Telefon:
          </div>
          <div>{{ id_customers.phone }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="formData.onum">
          <div class="font-weight-bolder">
            Teklif No:
          </div>
          <div>{{ formData.onum }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="formData.odate">
          <div class="font-weight-bolder">
            Teklif Tarihi:
          </div>
          <div>{{ moment(formData.odate).format('Do MMMM YYYY dddd') }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="formData.title">
          <div class="font-weight-bolder">
            Teklif Başlık:
          </div>
          <div>{{ formData.title }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="formData.delivery_time">
          <div class="font-weight-bolder">
            Teslim Süresi:
          </div>
          <div>{{ formData.delivery_time }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="formData.delivery_location">
          <div class="font-weight-bolder">
            Teslim Yeri:
          </div>
          <div>{{ formData.delivery_location }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="formData.payment">
          <div class="font-weight-bolder">
            Ödeme:
          </div>
          <div>{{ formData.payment }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="formData.terms">
          <div class="font-weight-bolder">
            Özel Şartlar:
          </div>
          <div v-html="formData.terms" />
        </b-list-group-item>
      </b-list-group>
    </b-card-text>
    <hr
      v-if="formData.products.length > 0"
      class="mt-2"
    >
    <b-card-title
      v-if="formData.products.length > 0"
      class="mt-2"
    >
      Teklif İçeriği
    </b-card-title>
    <b-card-text v-if="formData.products.length > 0">
      <b-list-group>
        <b-list-group-item
          v-for="(product,key) in formData.products"
          :key="key"
        >
          <div v-if="product.id_products.rowTotal > 0">
            <div>{{ product.id_products.brand }}</div>
            <div>
              {{ product.id_products.pcode }} {{ product.id_products.title }}
            </div>
            <div v-if="product.id_products.unit">
              <span v-if="product.id_products.quantity">{{ product.id_products.quantity }}</span>
              <span v-if="product.id_products.unit"> {{ product.id_products.unit }}</span>
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item class="font-weight-bold font-medium-5">
          Toplam Tutar: {{ publicTotal() }}
        </b-list-group-item>
      </b-list-group>
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BCardTitle, BListGroup, BListGroupItem,
} from 'bootstrap-vue'

export default {
  name: 'OfferSummary',
  components: {
    BCard,
    BCardText,
    BListGroup,
    BListGroupItem,
    BCardTitle,
  },
  props: ['id_customers', 'formData'],
  methods: {
    publicTotal() {
      let result = 0
      if (this.formData.products.length > 0) {
        const { products } = this.formData
        const total = []
        products.forEach(e => {
          if (e.id_products.rowTotal) {
            total.push(e.id_products.rowTotal)
          }
        })
        const { currencySymbol } = products[0].id_products
        result = total.reduce((a, b) => a + b, 0)
        result = new Intl.NumberFormat('tr-TR').format(result) + currencySymbol
      }
      return result
    },
  },
}
</script>

<style scoped>

</style>
